import React, { useState, useEffect, useRef, useMemo } from "react";
import { useBotPhotos } from "../../hooks/useBotPhotos";
import BotAvatar from "../BotAvatar/BotAvatar";
import "../../pages/Tracking/botselector.css";

export default function MultiBotSelector({
  bots = [],
  selected = [],
  onChange,
  placeholder = "Selecione os bots",
}) {
  const [open, setOpen] = useState(false);
  const wrapperRef = useRef(null);

  const sortedBots = useMemo(() => {
    if (!bots || !Array.isArray(bots)) return [];
    return [...bots];
  }, [bots]);

  const photoUrls = useBotPhotos(sortedBots);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
        setOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const toggle = (botId) => {
    const next = selected.includes(botId)
      ? selected.filter((id) => id !== botId)
      : [...selected, botId];
    onChange && onChange(next);
  };

  return (
    <div className="bot-multi-selector-wrapper" ref={wrapperRef}>
      <div className="bot-selector-trigger" onClick={() => setOpen(!open)}>
        {selected.length === 0 ? (
          <span className="bot-selector-placeholder">{placeholder}</span>
        ) : (
          <div className="bot-selector-selected">
            {selected.map((botId) => {
              const bot = bots.find((b) => b.id === botId);
              const isInactive = bot?.is_active === false;
              return bot ? (
                <span key={bot.id} className={`bot-badge ${isInactive ? "botInactive" : ""}`} style={{ display: 'inline-flex', alignItems: 'center', gap: 5 }}>
                  <BotAvatar photoUrl={photoUrls[bot.id]} size={24} />
                  {bot.bot_username || bot.bot_name}
                  {isInactive && <span className="botInactive"> - Inativo</span>}
                  <i
                    className="fas fa-times"
                    onClick={(e) => {
                      e.stopPropagation();
                      toggle(bot.id);
                    }}
                  />
                </span>
              ) : null;
            })}
          </div>
        )}

        <i className={`fas fa-chevron-${open ? "up" : "down"} bot-selector-icon`} />
      </div>

      {open && (
        <div className="bot-selector-dropdown">
          {sortedBots.map((bot) => {
            const isInactive = bot?.is_active === false;
            return (
              <div
                key={bot.id}
                className={`bot-option ${selected.includes(bot.id) ? "selected" : ""} ${isInactive ? "botInactive" : ""}`}
                onClick={() => toggle(bot.id)}
              >
                <div className="bot-option-check">
                  {selected.includes(bot.id) && <i className="fas fa-check" />}
                </div>
                <BotAvatar photoUrl={photoUrls[bot.id]} size={24} style={{ marginRight: 4 }} />
                <span className={`bot-option-name ${isInactive ? "botInactive" : ""}`}>
                  {bot.bot_username || bot.bot_name}
                  {isInactive && <span className="botInactive"> - Inativo</span>}
                </span>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}